<template>
  <v-dialog v-model="dialog" persistent>
    <v-card>
      <v-card-title>Edit Tooltip</v-card-title>
      <v-card-text>
        <v-text-field v-model="description" label="Beschreibung" />
        <MathField v-model="formula" @legend="updateLegendObject" />
        <!-- <v-textarea v-model="legend" label="Legende" /> -->

        <v-row v-for="key in Object.keys(legendObject)" noGutters>
            <v-col cols="3">
                <span v-html="key"></span>
            </v-col>
            <v-col cols="8">
                <v-text-field v-model="legendObject[key]"></v-text-field>
            </v-col>
            <v-col cols="1">
                <v-btn @click="delete legendObject[key]">Delete</v-btn>
            </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="dialog = false">Cancel</v-btn>
        <v-btn @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { onMounted, Ref, ref } from 'vue';
import MathField from '../Elements/MathField.vue';
import { useMainStore } from '@/stores/mainStore';
import axios from 'axios';

const mainStore = useMainStore();

const props = defineProps({
  name: {
    type: String,
    required: true,
  }
})

const dialog = defineModel()

const description = ref('');
const legend = ref('');
const formula = ref('');

const legendObject: Ref<Record<string, string>> = ref({})

function updateLegendObject(items: string[]) {
  for (const item of items) {
    if (!legendObject.value[item]) {
      legendObject.value[item] = '';
    }
  }
}

onMounted(() => {
  if (mainStore.tooltips[props.name]){
    description.value = mainStore.tooltips[props.name].description;
    try {
      legendObject.value = mainStore.tooltips[props.name].legend;
    } catch {
      legendObject.value = {};
    }
    formula.value = mainStore.tooltips[props.name].formula;
  }
})

function save() {
  axios.post(`/api/tooltips`, {
    id: props.name,
    description: description.value,
    legend: JSON.stringify(legendObject.value),
    formula: formula.value,
  }).then(() => {
    mainStore.tooltips[props.name] = {
      description: description.value,
      legend: legendObject.value,
      formula: formula.value,
    };
    dialog.value = false;
  });
}

</script>
